import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  forwardRef,
  inject,
  signal,
} from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { MenuItem } from '../menu/menu-item';
import { MenuComponent, MenuDirective } from '../menu/menu.directive';
import { NavigationBarComponent } from './navigation-bar.component';

@Component({
  selector: 'core-nav-child',
  imports: [CommonModule, RouterModule, NavigationBarComponent],
  providers: [
    {
      provide: MenuComponent,
      useExisting: forwardRef(() => NavigationChildComponent),
    },
  ],
  hostDirectives: [MenuDirective],
  template: `
    <core-nav-bar [menu]="menu()" />
    <div
      class="bg-2 min-h-full h-auto w-full p-8 shadow-2xl"
      [ngClass]="hostClass()"
    >
      <router-outlet></router-outlet>
    </div>
  `,
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavigationChildComponent extends MenuComponent {
  private readonly route = inject(ActivatedRoute);
  public override readonly menu = signal<MenuItem[]>([]);
  protected hostClass;

  public constructor() {
    super();
    this.hostClass = signal(this.route.snapshot.data['hostClass'] ?? '');
  }
}
